import { useGraphQLQuery } from '@betterment/graphql';

import { DirectTradingAccountInflowOptionsDocument } from './directTradingAccountInflowOptions.generated';

type DepositOption = {
  destinationLegacySubAccountId: number;
};

type TransferOption = {
  sourceLegacySubAccountId: number;
  destinationLegacySubAccountId: number;
};

type Options = {
  depositOption: DepositOption;
  transferOption: TransferOption | null;
};

export function useDirectTradingAccountInflowOptions({
  accountId,
  throwOnError = false,
}: {
  accountId: string;
  throwOnError?: boolean;
}): Options | null {
  const { data } = useGraphQLQuery(DirectTradingAccountInflowOptionsDocument, {
    variables: { accountId },
    throwOnError,
  });

  if (!data) return null;

  const { directTradingAccount, legalSubAccounts } = data;

  const depositOption = {
    destinationLegacySubAccountId: directTradingAccount.legacySubAccountId,
  };
  const cashAccount = legalSubAccounts.filter(a => a.__typename === 'CashAccount').find(a => a.balance.cents > 0);
  const transferOption = cashAccount
    ? {
        sourceLegacySubAccountId: cashAccount.legacySubAccountId,
        destinationLegacySubAccountId: directTradingAccount.legacySubAccountId,
      }
    : null;

  return {
    depositOption,
    transferOption,
  };
}
